import { BaseContainerModel } from '../../base-container.model';

export class EntityCreditAvailabilityModel extends BaseContainerModel {
  credit_limit: number;
  sum_arap_bal: number;
  sum_amount_open: number;
  available_credit: number;
}
